export const STRUCTURE_PRODUCT_CENTER = .618

export function separateStructureLabels(positions, height, gap = 4) {
  const sorted = positions.map(position => ({ ...position, labelY: position.anchorY })).sort((a, b) => a.anchorY - b.anchorY)
  let bottom = 8
  for (const position of sorted) {
    position.labelY = Math.max(position.anchorY, bottom + position.height / 2)
    bottom = position.labelY + position.height / 2 + gap
  }
  let top = height - 8
  for (const position of sorted.toReversed()) {
    position.labelY = Math.min(position.labelY, top - position.height / 2)
    top = position.labelY - position.height / 2 - gap
  }
  return sorted
}

export function fitStructureFrame(frameWidth, frameHeight, width, height, labelWidth) {
  const labelRight = 8 + labelWidth
  const labelClearance = labelRight + 8 + (width <= 600 ? 16 : 28)
  const horizontalRoom = Math.max(.01, Math.min(STRUCTURE_PRODUCT_CENTER - labelClearance / width, 1 - 20 / width - STRUCTURE_PRODUCT_CENTER))
  const aspect = width / height
  return Math.max(frameHeight * height / Math.max(1, height - 40), frameWidth / (2 * horizontalRoom) / aspect) / 2
}
